import { render, staticRenderFns } from "./VisitorTrashedList.vue?vue&type=template&id=519aeb7a"
import script from "./VisitorTrashedList.vue?vue&type=script&lang=js"
export * from "./VisitorTrashedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports